import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { getHistoryQuestionnairesTable } from '../../../Model/QuestionnaireTableModel'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'

export interface IHistoryPageProps {
}

@inject('questionnairesStore')
@observer
export default class HistoryPage extends React.Component<IHistoryPageProps> {
    render() {

        return (
            <div className="questionaires row">
                <div className="page col-12">
                    <PageSizeComponent/>
                    <ExportToCsvComponent exportType={ExportType.QAll} />
                    {getHistoryQuestionnairesTable()}
                </div>
                {/* <div className="tip">
                    <em>{ls.t('Tip: Hold shift when sorting to multi-sort!')}</em>
                </div> */}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Questionnaire/HistoryPage.tsx